import BaseBehavior from '../../../framework/base/base';
import { screenSmallerThan } from '../../../shared/utilities/screenSize';
import * as verticalLoopAnim from '../../../shared/utilities/vertical-loop-animation';

export const Constants = {
	cardContainerHeight: 460,
	imageContainerHeight: 765,
	animationDuration: 1
};

export default class SwitchingCarousel extends BaseBehavior {
	constructor(element) {
		super(element);
		if (screenSmallerThan('sm')) {
			const closedStateBgcolor = element.dataset.bgcolorClosed;
			const expandedStateBgcolor = this.element.dataset.bgcolorExpanded;
			Array.from(this.element.querySelectorAll('.v2-accordion')).forEach(item => {
				item.style.backgroundColor = closedStateBgcolor;
			});
			this.addEventListenersMobile(closedStateBgcolor, expandedStateBgcolor);
		} else {
			this.initDomCache();
			this.timer = +element.dataset.timer * 10;
			this.hoveredState = false;
			this.maxCardItems = +element.dataset.totalItems;
			Array.from(this.dom.imageContainer.querySelectorAll('div.image')).forEach(
				(imageBox, index) => {
					imageBox.style.backgroundImage = `url(${imageBox.dataset[`srcImg-${index + 1}`]})`;
				}
			);
			verticalLoopAnim.setupForLoopAnimation.call(this, this.dom.imageContainer, 'div.image');
			verticalLoopAnim.setupForLoopAnimation.call(
				this,
				this.dom.cardContainer,
				'.content-container__content'
			);

			this.previousItemId = 1;
			this.currentItemId = 2; // initially after setup loop animation, 1st card becomes second
			this.dom.cardContainer.style.transform = `translateY(-${Constants.cardContainerHeight}px)`; // since we are cloning 2 nodes
			this.dom.imageContainer.style.transform = `translateY(-${Constants.imageContainerHeight}px)`; // since we are cloning 2 nodes
			this.addEventListeners();
			this.transitionDone = true;
			this.progressBar = this.element.querySelector('.progress-bar-container .bar');
			if (this.progressBar) {
				this.startProgressBar();
			}
		}
	}

	startProgressBar(isAnimationResume) {
		let width = isAnimationResume ? +this.progressBar.style.width.split('%')[0] : 1;
		this.progressBarTimer = setInterval(() => {
			if (width >= 100) {
				clearInterval(this.progressBarTimer);
				this.navigate('down');
			} else {
				width++;
				this.progressBar.style.width = `${width}%`;
			}
		}, this.timer);
	}

	resetProgressBar() {
		this.progressBar.style.width = '0%';
		if (!this.hoveredState) {
			this.startProgressBar();
		}
	}

	addEventListeners() {
		const leftNavLink = this.element.querySelector('.left-navigation-links');
		this.addEventListener(leftNavLink, 'click', e => {
			const listItem = e.target.closest('li');
			if (listItem) {
				this.renderCard(listItem.dataset.target);
			}
		});
		const cardsContainer = this.element.querySelector('.slider-cards-container');
		this.addEventListener(this.dom.upNavigation, 'click', this.navigate.bind(this, 'up'));
		this.addEventListener(this.dom.downNavigation, 'click', this.navigate.bind(this, 'down'));
		this.addEventListener(cardsContainer, 'mouseenter', this.pauseAnimation.bind(this));
		this.addEventListener(cardsContainer, 'mouseleave', this.resumeAnimation.bind(this));
		this.addEventListener(
			this.dom.cardContainer,
			'transitionend',
			verticalLoopAnim.ontransitionendNew.bind(
				this,
				[this.dom.cardContainer, this.dom.imageContainer],
				[Constants.cardContainerHeight, Constants.imageContainerHeight],
				this.maxCardItems + 2
			)
		);
	}

	pauseAnimation() {
		if (this.progressBarTimer) clearInterval(this.progressBarTimer);
		this.hoveredState = true;
	}

	resumeAnimation() {
		if (this.progressBarTimer) clearInterval(this.progressBarTimer);
		this.startProgressBar(true);
		this.hoveredState = false;
	}

	navigate(direction) {
		if (this.transitionDone) {
			clearInterval(this.progressBarTimer);
			this.resetProgressBar();
			this.previousItemId = this.currentItemId;
			if (direction === 'down') {
				if (this.currentItemId === this.maxCardItems + 2) {
					this.currentItemId = 1;
				} else {
					this.currentItemId = +this.currentItemId + 1;
				}
			} else if (this.currentItemId === 1) {
				this.currentItemId = this.maxCardItems + 2;
			} else {
				this.currentItemId = +this.currentItemId - 1;
			}

			const duration = Constants.animationDuration;
			this.runAnimation(duration, this.currentItemId - 1, false);
		}
	}

	renderCard(id) {
		clearInterval(this.progressBarTimer);
		this.resetProgressBar();
		this.previousItemId = this.currentItemId;
		const cardId = +id.split('-')[2];
		this.currentItemId = cardId + 1;
		let duration = Constants.animationDuration;
		if (Math.abs(this.currentItemId - this.previousItemId) > 1) {
			duration = 0;
		}
		this.runAnimation(duration, cardId, true);
	}

	runAnimation(duration, id, type) {
		this.transitionDone = false;
		const cardIndexToRender = type ? id : this.currentItemId - 1;
		this.dom.cardContainer.style.transition = `${duration}s cubic-bezier(0.7, 0, 0.20, 1)`;
		this.dom.imageContainer.style.transition = `${duration}s cubic-bezier(0.7, 0, 0.20, 1)`;
		this.dom.cardContainer.style.transform = `translateY(-${
			cardIndexToRender * Constants.cardContainerHeight
		}px)`;
		this.dom.imageContainer.style.transform = `translateY(-${
			cardIndexToRender * Constants.imageContainerHeight
		}px)`;
		let updatedId;
		if (id === 0) {
			updatedId = this.maxCardItems;
		} else if (id - this.maxCardItems >= 1) {
			updatedId = 1;
		} else {
			updatedId = id;
		}
		this.toggleActiveLink(updatedId);
	}

	toggleActiveLink(id) {
		const leftNavigationLinks = this.element.querySelector('.left-navigation-links');
		Array.from(leftNavigationLinks?.querySelectorAll('li')).forEach(item => {
			item.classList.remove('active');
		});
		leftNavigationLinks?.querySelector(`#card-${id}`).classList.add('active');
	}

	addEventListenersMobile(closedStateBgcolor, expandedStateBgcolor) {
		const handleClick = event => {
			event.stopImmediatePropagation(); // to stop click handler running twice in unit test case
			const self = event.target.type === 'checkbox' ? event.target : null;
			if (self) {
				const activeAccordion = self.parentElement;
				if (activeAccordion.classList.contains('active')) {
					// if accordion is already opened
					activeAccordion.classList.remove('active');
					this.resetAllOptions(closedStateBgcolor);
					return;
				}
				Array.from(this.element.querySelectorAll('.v2-accordion')).forEach(item => {
					const check = item.querySelector('input[type="checkbox"]');
					if (check !== self) {
						// eslint-disable-next-line
                        check.checked = false;
						item.style.backgroundColor = expandedStateBgcolor;
						item.classList.remove('active');
					} else {
						item.classList.add('active');
						item.style.backgroundColor = closedStateBgcolor;
					}
				});
			}
		};

		this.addEventListener(this.element, 'click', handleClick);
	}

	resetAllOptions(closedStateBgcolor) {
		Array.from(this.element.querySelectorAll('.v2-accordion')).forEach(item => {
			item.style.backgroundColor = closedStateBgcolor;
		});
	}

	removeEventListeners() {
		if (screenSmallerThan('sm')) {
			this.removeEventListener(this.element, 'click');
		} else {
			const leftNavLink = this.element.querySelector('.left-navigation-links');
			this.removeEventListener(leftNavLink, 'click');
			this.removeEventListener(this.dom.upNavigation, 'click');
			this.removeEventListener(this.dom.downNavigation, 'click');
			this.removeEventListener(this.dom.cardContainer, 'transitionend');
		}
	}

	cleanup() {
		this.removeEventListeners();
	}
}
